import { GetKaroakeListDto } from '../../../dto/getkaroakelist/getkaroakelistdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface GetKaroakeListRequest extends APIRequest
{
    getKaroakeListRequest(): GetKaroakeListDto;
}

export class GetKaroakeListRequestImpl extends APIRequestDtoImpl implements GetKaroakeListRequest
{
    constructor(private getKaroakeListData: GetKaroakeListDto)
    {
        super();
    }

    getKaroakeListRequest(): GetKaroakeListDto
    {
        return this.getKaroakeListData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/karoake/getkaroakelist/getkaroakelistrequest.tsx